import * as AuthService from '@/services/AuthService';
import { storeInstance as Store } from '@/store';

export const keyAdmin = 'admin';
export const externalUsersAccessRefreshEvent = 'EXTERNAL_USERS_ACCESS_REFRESH';
const defaultConectada = 'Ninguno';
const conectadaOptions = ['Nautilus', 'Dinapsis', 'Ninguno'];
const clientId = process.env.VUE_APP_OPENID_CLIENTID
  ? process.env.VUE_APP_OPENID_CLIENTID
  : null;

function getTokenRoles () {
  const token = AuthService.tokenParsed() || {};
  return token.roles || [];
}

function getActualRoles () {
  const roles = AuthService.tokenParsed().roles;
  return roles
    .map((rol) => rol.substring(rol.indexOf('_') + 1));
}

function getActualRolesByClientId () {
  const roles = AuthService.tokenParsed().roles;
  return roles
    .filter((rol) => rol.startsWith(clientId))
    .map((rol) => rol.substring(rol.indexOf('_') + 1));
}

export function checkIfExistRole (user, roleToSearch) {
  let existRole = false;
  roleToSearch.forEach(item => {
    if (user.role.includes(item)) {
      existRole = true;
    }
  });
  return existRole;
}

export function isAdminAnyClient () {
  const roles = getActualRoles();

  return roles.includes(keyAdmin);
}

export function isAdminOfApplication (applicationId) {
  const roles = getTokenRoles();

  return roles.includes(applicationId + '_' + keyAdmin);
}

export function normalizeConectada (value) {
  if (value === true) return 'Dinapsis';
  if (value === false || value === null || value === undefined) return defaultConectada;
  if (conectadaOptions.includes(value)) return value;
  return defaultConectada;
}

export function getAdminApplicationIds () {
  const adminSuffix = '_' + keyAdmin;
  const roles = getTokenRoles();
  const adminApplicationIds = roles
    .filter(role => role.endsWith(adminSuffix))
    .map(role => role.substring(0, role.length - adminSuffix.length))
    .filter(applicationId => applicationId && applicationId !== clientId);

  return adminApplicationIds;
}

export function hasApplicationAdminRoles () {
  return getAdminApplicationIds().length > 0;
}

export function isSuiteAdmin () {
  const roles = getTokenRoles();
  const suiteAdminRole = clientId + '_' + keyAdmin;

  return roles.includes(suiteAdminRole);
}

export function canAccessExternalUsers (applications) {
  if (!Array.isArray(applications)) {
    return false;
  }

  const adminApplicationIds = getAdminApplicationIds().map(applicationId => String(applicationId));
  return applications.some(application => {
    const applicationId = String(application.id);
    const normalizedConectada = normalizeConectada(application.conectada);
    const isAdminOfThisApplication = adminApplicationIds.includes(applicationId);
    const isDinapsis = normalizedConectada === 'Dinapsis';

    return isAdminOfThisApplication && isDinapsis;
  });
}

export async function shouldHideExternalUsers () {
  const userHasApplicationAdminRoles = hasApplicationAdminRoles();
  const userIsSuiteAdmin = isSuiteAdmin();

  if (!userHasApplicationAdminRoles || userIsSuiteAdmin) {
    return false;
  }

  let request = {
    controller: '/Aplicacion',
    opts: {
      errorHandleRedirect: false
    }
  };

  return Store.dispatch('PF/getSuit', request)
    .then(response => {
      return !canAccessExternalUsers(response.data);
    })
    .catch(() => {
      return true;
    });
}

export function isSuperAdmin () {
  const roles = getActualRolesByClientId();

  return roles.includes(keyAdmin);
}

export function mutateAdmintoSuperAdmin (value) {
  const positionClientAdmin = value.role.indexOf('admin');
  if (positionClientAdmin === -1) return;
  value.role[positionClientAdmin] = 'superadmin';
}
export async function getEntidadesVisibles () {
  Store.commit('PF/haveEntidadesVisibles', false);
  let request = {
    controller: '/Entidad'
  };

  await Store.dispatch('PF/getSuit', request)
    .then((response) => {
      // comprobar que haya alguna entidad visible en el array
      response.data.forEach(element => {
        if (element.visible === true) {
          // mutamos la propiedad
          Store.commit('PF/haveEntidadesVisibles', true);
        }
      });
    });
}

export async function getEntidadesVisiblesRelated () {
  Store.commit('PF/haveEntidadesVisiblesRelated', false);

  let requestUser = {
    controller: '/EntidadUserRelatedVisible/' + Store.getters['PF/userId']
  };

  await Store.dispatch('PF/getSuit', requestUser)
    .then((response) => {
      Store.commit('PF/haveEntidadesVisiblesRelated', response.data);
    });
}

export async function isAnyEntidadAdmin (user) {
  let request = {
    controller: '/AdminEntidad',
    data: {
      userId: user.nameid,
      PageNumber: 0,
      PageSize: 10
    }
  };

  await Store.dispatch('PF/getSuit', request)
    .then((response) => {
      Store.commit('PF/setIsAdminEntidad', response.data.length > 0);
    });
}

export async function isAnyDeliveryUser (user) {
  let request = {
    controller: '/Authorization/DeliveryUser/Users/' + user.nameid
  };

  await Store.dispatch('PF/getSuit', request)
    .then((response) => {
      Store.commit('PF/setIsDeliveryUser', response.data > 0);
    });
}
